import { axiosInstance } from ".."

const currency = async (country) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`public/geolist/currency/${country}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default currency;